// extracted by mini-css-extract-plugin
export default {"button":"Link_button__Xly76","disabled":"Link_disabled__9vhwO"};